import { Breadcrumb } from 'antd';
import React from "react";

export default (() => {
  return (
    <Breadcrumb style={{textAlign: 'left'}}>
      <Breadcrumb.Item>ip白名单列表</Breadcrumb.Item>
    </Breadcrumb>
  )
})